export const OLD_NEWS_NEW_ARTICLE = (cppId: string) =>
  `/news/article/page/${cppId}/edit/new`;

export const INSIDER_ARTICLE_EDITOR_PATH = (insiderPageName: string) => {
  return `/news/article/insider/${insiderPageName}/edit/new`;
};

export const CONTENT_SOURCE_XING = 'xing.com';
export const ARTICLES_ARTICLE_EDIT_LINK = (articleId: string) =>
  `/news/article/${articleId}/edit`;

export const DISCOVERY_DETAIL_ACTIVITIES = (
  socialInteractionIdSlugged: string
) => `/discover/detail-activities/${socialInteractionIdSlugged}`;
